import columns from '../../../../../react-table/helpers/columns';

export const predesSendingResdesReceivingConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row['predes.sender.mailbox'] !== rowInfo.row['resdes.receiver.mailbox']) {
      className = 'bg-blue-spindle';
    }
  }
  return {
    className,
  };
};

export const predesReceivingResdesSendingConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row['predes.receiver.mailbox'] !== rowInfo.row['resdes.sender.mailbox']) {
      className = 'bg-orange-amber';
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn, NumberColumn,
  } = columns(data);
  return [
    {
      Header: 'PREDES',
      columns: [
        new TextColumn('Sender', 'predes.sender.operatorCode'),
        new TextColumn('Receiver', 'predes.receiver.operatorCode'),
        new TextColumn('Sending mailbox', 'predes.sender.mailbox').withGetProps(predesSendingResdesReceivingConditionalProps),
        new TextColumn(' Receiving mailbox', 'predes.receiver.mailbox').withGetProps(predesReceivingResdesSendingConditionalProps),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new TextColumn('Sender', 'resdes.sender.operatorCode'),
        new TextColumn('Receiver', 'resdes.receiver.operatorCode'),
        new TextColumn('Sending mailbox', 'resdes.sender.mailbox').withGetProps(predesReceivingResdesSendingConditionalProps),
        new TextColumn(' Receiving mailbox', 'resdes.receiver.mailbox').withGetProps(predesSendingResdesReceivingConditionalProps),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new TextColumn('Despatch type', 'receptacles.despatchType'),
        new NumberColumn('Count', 'receptacles.count'),
        new TextColumn('Receptacle ID example', 'receptacles.receptacleIdExample')
          .withWidth(300),
      ],
    },
  ];
};
